/* Packages */
import React from "react";

/* Components */
import { CrossIcon, ChevronIconRight } from "../common/Icons";

/* Helpers */

export default function CompareNotificationComponent({ items, dismissable, setShowNotification, comparingUrl }) {
    
    const url = new URL(window.location.origin + comparingUrl);
    const searchParams = url.searchParams;

    items.forEach(vehicle => {
        searchParams.append('uuid[]', vehicle.id);
    });

    return (
        <>
            <div className="d-flex align-items-center mb-lg-3">
                <div className="d-none d-lg-flex align-items-center">
                    <span className="toast__badge badge badge-primary">{items.length}</span>
                    <p className="toast__title ml-2 mb-0">{window.Translator.trans("app.comparing.vehicle_overview.notification.title")}</p>
                </div>
                {dismissable && (
                    <button
                        className="toast__btn btn btn-link d-flex align-items-center text-base p-0 ml-2"
                        onClick={() => setShowNotification(false)}
                        type="button">
                        <CrossIcon className="icon icon--24 icon--close" />
                    </button>
                )}
            </div>
            <a
                href={url.href}
                title="Vergelijken"
                className="toast__btn btn btn-sm btn-block btn-primary">
                <span className="btn-text d-flex align-items-center justify-content-center">
                    <span className="toast__badge badge badge-light mr-2 d-lg-none">{items.length}</span>
                    <span>{window.Translator.trans("app.comparing.vehicle_overview.notification.button_title")}</span>
                </span>
                <ChevronIconRight className="btn__icon icon icon--24" />
            </a>
        </>
    );
}
